import { loadJson, loadJsonEnc } from '../core/loadjson';
import { GPSCoordinate } from '../core/gpscoordinate';
import { StringHelpers } from '../core/stringhelpers';
import { storagepath, renc } from './storagepath';
import { VaxiluskernaMarker } from '../map/vaxiluskernamarker';
import { Application } from '../main';

declare const Fuse:any;

export type PlaceOpenHoursDay = {
    open?: string,
    close?: string,
    closeAllDay?:boolean
}
export type PlaceOpenHours = {
    monday?: PlaceOpenHoursDay,
    tuesday?: PlaceOpenHoursDay,
    wednesday?: PlaceOpenHoursDay,
    thursday?: PlaceOpenHoursDay,
    friday?: PlaceOpenHoursDay,
    saturday?: PlaceOpenHoursDay,
    sunday?: PlaceOpenHoursDay
}
export type ReceptionOutDatabaseShortInfo = {
    name?: string, //must be set (for display on map)
    address?: string, //must be present (part of search)
    position?: {lat:number, lng: number}, //must be present (part of search and position)
    slug?:string, //must be present
    group?:string, //present if set

    marker?:VaxiluskernaMarker //set dynamically within local application
}
export type ReceptionOutDatabaseDetailedInfo = {
    name?: string, //must be set (for display on map)
    phone?:string, //may not be present if fetched from place id
    web?:string,   //may not be present if fetched from place id
    address?: string, //must be present (part of search)
    position?: {lat:number, lng: number}, //must be present (part of search and position)
    place_id?: string, //must be present
    slug?:string, //must be present
    group?:string, //present if set

    freetextHtml?:string, //set through cms

    hideHours?:boolean,
    customHours?:PlaceOpenHours,

    showPhoto?:boolean,
    photoIndex?:number,
}
export type ReceptionsOutShortRoot = {[key: string]: ReceptionOutDatabaseShortInfo};


export type ReceptionProximityInfo = {
    reception: ReceptionOutDatabaseShortInfo,
    distance: number
}
export type ReceptionSearchInfo = {
    reception: ReceptionOutDatabaseShortInfo,
    score: number
}
type FuseSearchResultType = {
    item:ReceptionOutDatabaseShortInfo,
    matches:Array<{key:string, value:string}>,
    refIndex:number,
    score: number
}
export class Receptions {
    
    public static receptions:{[key: string]: ReceptionOutDatabaseShortInfo};
    public static receptionsArr:Array<ReceptionOutDatabaseShortInfo>;
    private static fuse: any;
    static visibleMarkerCount: number;
    public static bounds:google.maps.LatLngBounds;
    public static async load():Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                Receptions.receptions = (await loadJsonEnc(storagepath+renc+"&rnd="+(Math.round(Math.random()*9999999)), "aYuRewWerTgCsSaf")).receptions;
                Receptions.receptionsArr = [];
                Receptions.bounds = new google.maps.LatLngBounds();
                //console.log("receptions:", Receptions.receptions);
                for(let m in Receptions.receptions) {
                    let c = Receptions.receptions[m];
                    try {
                        Receptions.bounds.extend(c.position);
                        Receptions.receptionsArr.push(c);
                    } catch(e) {
                        console.error("Reception data problem (objname: '"+m+"'): ", c);
                        delete Receptions.receptions[m];
                    }
                }
                this.fuse = new Fuse(Receptions.receptionsArr, {
                    keys: [
                        {
                            name: 'name',
                            weight: 1
                        },
                        {
                            name: 'address',
                            weight: 1
                        }
                    ],
                    includeScore: true,
                    includeMatches: true
                });
                //console.log("Loaded " + Receptions.receptionsArr.length + " receptions");
                resolve(); 
            } catch(e) {
                reject(e);
            }
        });
    }
    public static onMapBounds(mapBounds: google.maps.LatLngBounds) {
        let visibleMarkerCount = 0;
        for(let m in Receptions.receptions) {
            let c = Receptions.receptions[m];
            c.marker.onMapBounds(mapBounds);
            if(c.marker.isWithinBounds) visibleMarkerCount++;
        }
        Receptions.visibleMarkerCount = visibleMarkerCount;
        for(let m in Receptions.receptions) {
            let c = Receptions.receptions[m];
            c.marker.updateIcon();
        }
    }
    public static getReceptionDetails(slug:string):Promise<ReceptionOutDatabaseDetailedInfo> {
        return new Promise(async (resolve, reject) => {
            try {
                
                let api_url:string = "https://us-central1-vaxiluskerna-3.cloudfunctions.net/app/api/receptions/";
                let url:string = api_url+slug;
                let r:any = await loadJson(url);
                let slugdb = slug.replace(/-/gi, "_");

                //console.log(r);
                //console.log(slugdb);
                //console.log(r[slugdb]);

                resolve(r[slug.replace(/-/gi, "_")]);
            } catch(e) {
                reject(e);
            }
        });
    }
    public static getReceptionBySlug(slug:string):Promise<ReceptionOutDatabaseShortInfo> {
        return new Promise(async (resolve, reject) => {
            try {
                for(let m in Receptions.receptions) {
                    if(Receptions.receptions[m].slug==slug) return resolve(Receptions.receptions[m]);
                }
                resolve(null);
            } catch(e) {
                reject(e);
            }
        });
    }
    public static getClosestTo(coord: GPSCoordinate):Array<ReceptionProximityInfo> {
        let r:Array<ReceptionProximityInfo> = [];
        for(let m in Receptions.receptions) {
            let c = Receptions.receptions[m];
            let distance = coord.distance(new GPSCoordinate(c.position.lat, c.position.lng));
            r.push({
                reception: c,
                distance: distance
            });
        }
        r = r.sort((a:ReceptionProximityInfo, b:ReceptionProximityInfo) => {
            if(a.distance<b.distance) return -1;
            if(a.distance>b.distance) return 1;
            return 0;
        });
        return r;
    }
    /*public static search(search:string, limit:number = 5):ReceptionSearchInfo[] {
        let r:ReceptionSearchInfo[] = [];
        let getOrCreateRes = (item:ReceptionCondensedInfo):ReceptionSearchInfo => {
            for(let m in r) {
                if(r[m].reception.slug==item.slug) return r[m];
            }
            let n:ReceptionSearchInfo = {
                reception: item,
                score: 0
            };
            r.push(n);
            return n;
        }
        let strings:string[] = StringHelpers.getStringFragments(search);
        for(let m in strings) {
            let c = strings[m];
            let res:FuseSearchResultType[] = this.fuse.search(c, {limit: 10});
            console.log(res);
            for(let m2 in res) {
                let cres = res[m2];
                let resOutput = getOrCreateRes(cres.item);
                resOutput.score+=cres.score;
            }
        }
        return r;
        
    }*/
    public static search(search: string, maxMatches:number = -1):Array<ReceptionSearchInfo> {
        let r:Array<ReceptionSearchInfo> = [];
        for(let m in Receptions.receptions) {
            let c = Receptions.receptions[m];
            let score:number = 0;
            score += StringHelpers.search(c.name, search);
            score += StringHelpers.search(c.address, search);
            if(score>0) r.push({
                reception: c,
                score: score
            });
        }
        r = r.sort((a:ReceptionSearchInfo, b:ReceptionSearchInfo) => {
            if(a.score<b.score) return 1;
            if(a.score>b.score) return -1;
            return 0;
        });
        if(maxMatches>0) {
            if(r.length>maxMatches)
                return r.slice(0, maxMatches);
        }
        return r;
    }
    public static getDistance(coord:GPSCoordinate|null, reception:ReceptionOutDatabaseShortInfo):number {
        if(coord==null) return null;
        return coord.distance(new GPSCoordinate(reception.position.lat, reception.position.lng));
    }
}